import type { AppDispatch } from '../../data/store';
import type { WebSocketSessionInfo } from './webSocketService';

interface IProviderInvoiceDetail {
  tripLegInternalNoteID: string;
}

enum ProviderInvoiceEventType {}

/**
 * Method for handling all Task Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateProviderInvoice(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IProviderInvoiceDetail,
) {
  // switch (detailType) {}
}

export { ProviderInvoiceEventType, updateProviderInvoice };
